export const SIGNIN_TEXT_FIELDS = {
  TITLE: 'Sign in',
  SUBTITLE: 'Please enter your email and password for authorization.',
  BUTTON: 'Sign in',
  LINK: 'Forgot password?',
}
